module.exports = __webpack_public_path__ + "img/twitter.ee772aeb.svg";